import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import DashboardDiarioSupervisor from '../components/Supervisor/DashboardDiarioSupervisor';
import HistoricoVisitasSupervisor from '../components/Supervisor/HistoricoVisitasSupervisor';
import ResumoGeralSupervisor from '../components/Supervisor/ResumoGeralSupervisor';
import './Dashboard.css';

function SupervisorDashboard({ user }) {
    const [activeView, setActiveView] = useState('diario');

    return (
        <div>
            <Navbar user={user} />
            <div className="dashboard-container">
                <div className="view-switcher">
                    <button onClick={() => setActiveView('diario')} className={activeView === 'diario' ? 'active' : ''}>Painel Diário</button>
                    <button onClick={() => setActiveView('resumo')} className={activeView === 'resumo' ? 'active' : ''}>Resumo Geral</button>
                    <button onClick={() => setActiveView('historico')} className={activeView === 'historico' ? 'active' : ''}>Histórico de Visitas</button>
                </div>

                <div className="view-content">
                    {activeView === 'diario' && <DashboardDiarioSupervisor userLocalidades={user.localidades} user={user} />}
                    {activeView === 'resumo' && <ResumoGeralSupervisor userLocalidades={user.localidades} user={user} />}
                    {activeView === 'historico' && <HistoricoVisitasSupervisor userLocalidades={user.localidades} user={user} />}
                </div>
            </div>
        </div>
    );
}

export default SupervisorDashboard;
